import React from 'react';
import PropTypes from "prop-types";
import Control from "../Control";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import SelectFirm from "../SelectFirm/SelectFirm";
import {useVendorTypes, subtypesOf} from "../../vendor-types";

const VendorForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange, addNewItem}) => {
    const vendorTypes = useVendorTypes();
    const subtypes = subtypesOf(vendorTypes, data.VENDOR_TYPE);
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Vendor' : 'Add Vendor'}</div>
                {isFilter ? (
                    <Input theme={theme}
                           valueType='text'
                           name='NAME'
                           label='Name'
                           value={data.NAME}
                           handleParentChange={handleParentChange}
                    />
                ) : (
                    <React.Fragment>
                        <Input theme={theme}
                               valueType='text'
                               name='FIRST_NAME'
                               label='First Name'
                               value={data.FIRST_NAME}
                               handleParentChange={handleParentChange}
                        />
                        <Input theme={theme}
                               valueType='text'
                               name='LAST_NAME'
                               label='Last Name'
                               value={data.LAST_NAME}
                               handleParentChange={handleParentChange}
                        />
                    </React.Fragment>
                )}
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_NAME'
                       label='Company Name'
                       value={data.COMPANY_NAME}                      
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                    optionsType='vendorType'
                    options={vendorTypes.map((type) => type.NAME)}
                    value={data.VENDOR_TYPE}
                    valueKey='VENDOR_TYPE'
                    label='Vendor Type'
                    data={data}
                    handleParentChange={handleParentDropdownChange}
                />
                {subtypes.length ? (
                    <Dropdown theme={theme}
                        optionsType='vendorSubtype'
                        options={subtypes}
                        value={data.VENDOR_SUBTYPE}
                        valueKey='VENDOR_SUBTYPE'
                        label='Subtype'
                        data={data}
                        handleParentChange={handleParentDropdownChange}
                    />
                ) : null}
                {!isFilter ? (
                    <SelectFirm theme={theme}
                                value={data.FIRM_ID}
                                valueKey='FIRM_ID'
                                label='Firm'
                                data={data}
                                isFilter={isFilter}
                                withAddNew={false}
                                hasDrawer={false}
                                handleParentChange={handleParentDropdownChange}
                    />
                ) : null}
                
                
            </React.Fragment>
        ),
    ];
    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

VendorForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
    addNewItem: PropTypes.func,
};

export default VendorForm;